import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\CustomerAddressController::byContact
* @see app/Http/Controllers/Api/CustomerAddressController.php:19
* @route '/api/customer-addresses/by-contact'
*/
export const byContact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: byContact.url(options),
    method: 'get',
})

byContact.definition = {
    methods: ["get","head"],
    url: '/api/customer-addresses/by-contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::byContact
* @see app/Http/Controllers/Api/CustomerAddressController.php:19
* @route '/api/customer-addresses/by-contact'
*/
byContact.url = (options?: RouteQueryOptions) => {
    return byContact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::byContact
* @see app/Http/Controllers/Api/CustomerAddressController.php:19
* @route '/api/customer-addresses/by-contact'
*/
byContact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: byContact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::byContact
* @see app/Http/Controllers/Api/CustomerAddressController.php:19
* @route '/api/customer-addresses/by-contact'
*/
byContact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: byContact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::save
* @see app/Http/Controllers/Api/CustomerAddressController.php:131
* @route '/api/customer-addresses/save'
*/
export const save = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(options),
    method: 'post',
})

save.definition = {
    methods: ["post"],
    url: '/api/customer-addresses/save',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::save
* @see app/Http/Controllers/Api/CustomerAddressController.php:131
* @route '/api/customer-addresses/save'
*/
save.url = (options?: RouteQueryOptions) => {
    return save.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\CustomerAddressController::save
* @see app/Http/Controllers/Api/CustomerAddressController.php:131
* @route '/api/customer-addresses/save'
*/
save.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(options),
    method: 'post',
})

const customerAddresses = {
    byContact: Object.assign(byContact, byContact),
    save: Object.assign(save, save),
}

export default customerAddresses